import { Navigate, RouteObject } from "react-router";
import { CommitmentsRoute } from "@/routes/processes/[processId]/htz/commitments/commitments-route";
import { CommitmentRoute } from "@/routes/processes/[processId]/htz/commitments/[commitmentId]/commitment-route";
import { DataRoute } from "@/routes/processes/[processId]/htz/commitments/[commitmentId]/data/data-route";
import { WorkOrderRoute } from "./[commitmentId]/work-order/work-order-route";
import { PositionsRoute } from "./[commitmentId]/positions/positions-route";

export const htzCommitmentsRoutes: RouteObject[] = [
  {
    index: true,
    element: <CommitmentsRoute />,
  },
  {
    path: ":relationshipId/:commitmentId",
    element: <CommitmentRoute />,
    children: [
      {
        index: true,
        element: <Navigate to="data" replace />,
      },
      {
        path: "data",
        element: <DataRoute />,
      },
      {
        path: "work-order",
        element: <WorkOrderRoute />,
      },
      {
        path: "positions",
        element: <PositionsRoute />,
      },
    ],
  },
];
